import { DatePicker, Select, Skeleton } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import Chart from "react-google-charts";
import { useQuery } from "react-query";
import { columnChartConfigurationOptions } from "../../config";
import HTTP from "../../services/httpService";
import { disableFutureDates } from "../../services/util";

const { Option } = Select;

function AssigneeAvgTimeLog({ projects }) {
    const [assignee, setAssignee] = useState([]);
    const [columnChartData, setColumnChartData] = useState([]);
    const [defaultYear, setDefaultYear] = useState(moment());
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [formData, setFormData] = useState({
        assignee_id: "",
        staff_id,
        range_year: defaultYear.get("year"),
        project_id: "-1",
    });
    const {
        status,
        data: assigneeRes,
        refetch: fetchAssignee,
    } = useQuery(
        "assignee",
        async () => {
            return await HTTP("/analytics/getJiraAssignees", { staff_id });
        },
        { enabled: false },
    );

    const {
        status: columnChartStatus,
        data: columnChartDataRes,
        refetch,
    } = useQuery(
        "assigneeAvgWorkLog",
        async () => {
            return await HTTP("/analytics/getJiraAvgTimingByMonth", {
                ...formData,
            });
        },
        {
            enabled: false,
        },
    );

    useEffect(() => {
        if (status === "success") {
            setAssignee(assigneeRes.data);
        }
        if (columnChartStatus === "success") {
            setColumnChartData(columnChartDataRes.data);
        }
    }, [status, columnChartStatus, columnChartDataRes]);

    useEffect(() => {
        fetchAssignee();
        refetch();
    }, []);

    useEffect(() => {
        refetch();
    }, [formData]);

    function handleYearChange(date, dateString) {
        const yearSelected = dateString || moment().get("year");
        setDefaultYear(dateString === "" ? moment() : moment(dateString));
        const updatedFormData = {
            ...formData,
            range_year: yearSelected,
        };
        setFormData(updatedFormData);
    }

    function handleProjectSelectionChange(e) {
        let project_id = -1;
        if (e !== undefined) {
            [project_id] = e.split("#");
        }

        const updatedFormData = {
            ...formData,
            project_id,
        };
        setFormData(updatedFormData);
    }

    function handleAssigneeSelectionChange(e) {
        let assignee_id = "";
        if (e !== undefined) {
            [assignee_id] = e.split("#");
        }

        const updatedFormData = {
            ...formData,
            assignee_id,
        };
        setFormData(updatedFormData);
    }

    return (
        <>
            <div className="chart-selection-options">
                <DatePicker
                    className="year-picker"
                    defaultValue={defaultYear}
                    onChange={handleYearChange}
                    picker="year"
                    allowClear={false}
                    disabledDate={disableFutureDates}
                />
                <Select
                    allowClear
                    showSearch
                    placeholder="Project"
                    onChange={handleProjectSelectionChange}
                    className="jira-dashboard-select"
                >
                    {projects.map((e) => (
                        <Option key={`${e.project_id}#${e.project_name}`}>
                            {e.project_name}
                        </Option>
                    ))}
                </Select>
                <Select
                    allowClear
                    showSearch
                    placeholder="Assignee"
                    onChange={handleAssigneeSelectionChange}
                    className="jira-dashboard-select"
                >
                    {assignee.map((e) => (
                        <Option key={`${e.assignee_id}#${e.assignee_name}`}>
                            {e.assignee_name}
                        </Option>
                    ))}
                </Select>
            </div>
            {columnChartData.length > 0 ? (
                <Chart
                    className="charts"
                    chartType="ColumnChart"
                    height="50vh"
                    legendToggle
                    options={{
                        ...columnChartConfigurationOptions,
                        title: "Average Worklog By Month",
                    }}
                    data={columnChartData}
                />
            ) : (
                <Skeleton />
            )}
        </>
    );
}

export default AssigneeAvgTimeLog;
